/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bulkCreateFileNodes } from '../fn/file-system/bulk-create-file-nodes';
import { BulkCreateFileNodes$Params } from '../fn/file-system/bulk-create-file-nodes';
import { createFileNode } from '../fn/file-system/create-file-node';
import { CreateFileNode$Params } from '../fn/file-system/create-file-node';
import { deleteFileNode } from '../fn/file-system/delete-file-node';
import { DeleteFileNode$Params } from '../fn/file-system/delete-file-node';
import { FileNodeDto } from '../models/file-node-dto';
import { FileNodeDtoPage } from '../models/file-node-dto-page';
import { getFileNode } from '../fn/file-system/get-file-node';
import { GetFileNode$Params } from '../fn/file-system/get-file-node';
import { listFileNodes } from '../fn/file-system/list-file-nodes';
import { ListFileNodes$Params } from '../fn/file-system/list-file-nodes';
import { updateFileNode } from '../fn/file-system/update-file-node';
import { UpdateFileNode$Params } from '../fn/file-system/update-file-node';

@Injectable({ providedIn: 'root' })
export class FileSystemApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listFileNodes()` */
  static readonly ListFileNodesPath = '/v0/fileSystem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFileNodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFileNodes$Response(params?: ListFileNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<FileNodeDtoPage>> {
    return listFileNodes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listFileNodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFileNodes(params?: ListFileNodes$Params, context?: HttpContext): Observable<FileNodeDtoPage> {
    return this.listFileNodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileNodeDtoPage>): FileNodeDtoPage => r.body)
    );
  }

  /** Path part for operation `createFileNode()` */
  static readonly CreateFileNodePath = '/v0/fileSystem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFileNode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFileNode$Response(params: CreateFileNode$Params, context?: HttpContext): Observable<StrictHttpResponse<FileNodeDto>> {
    return createFileNode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFileNode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFileNode(params: CreateFileNode$Params, context?: HttpContext): Observable<FileNodeDto> {
    return this.createFileNode$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileNodeDto>): FileNodeDto => r.body)
    );
  }

  /** Path part for operation `getFileNode()` */
  static readonly GetFileNodePath = '/v0/fileSystem/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFileNode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFileNode$Response(params: GetFileNode$Params, context?: HttpContext): Observable<StrictHttpResponse<FileNodeDto>> {
    return getFileNode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFileNode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFileNode(params: GetFileNode$Params, context?: HttpContext): Observable<FileNodeDto> {
    return this.getFileNode$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileNodeDto>): FileNodeDto => r.body)
    );
  }

  /** Path part for operation `updateFileNode()` */
  static readonly UpdateFileNodePath = '/v0/fileSystem/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFileNode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFileNode$Response(params: UpdateFileNode$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateFileNode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFileNode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFileNode(params: UpdateFileNode$Params, context?: HttpContext): Observable<void> {
    return this.updateFileNode$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteFileNode()` */
  static readonly DeleteFileNodePath = '/v0/fileSystem/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFileNode()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFileNode$Response(params: DeleteFileNode$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteFileNode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFileNode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFileNode(params: DeleteFileNode$Params, context?: HttpContext): Observable<void> {
    return this.deleteFileNode$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bulkCreateFileNodes()` */
  static readonly BulkCreateFileNodesPath = '/v0/fileSystem/bulk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkCreateFileNodes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCreateFileNodes$Response(params: BulkCreateFileNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileNodeDto>>> {
    return bulkCreateFileNodes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkCreateFileNodes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCreateFileNodes(params: BulkCreateFileNodes$Params, context?: HttpContext): Observable<Array<FileNodeDto>> {
    return this.bulkCreateFileNodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FileNodeDto>>): Array<FileNodeDto> => r.body)
    );
  }

}
